import React from "react";
import { Prompt } from 'react-router'
import { GetMessage } from '../../variables/message'

export default class RouterChangePrompt extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            windowChangeAlert:true
        };
        this.inactivate = this.inactivate.bind(this)
    }

    inactivate(){
        this.setState({
            windowChangeAlert:false
        })
    }
    
    render() {
        return this.state.windowChangeAlert&&<Prompt
        message={GetMessage(2400)}
      />
    }
}
